import type { SeoMeta } from '$lib/seo';

export const load = (): { seo: SeoMeta } => ({
	seo: {
		title: 'On HIPAA — how Ekavi handles your patient data',
		description:
			'Ekavi Care is HIPAA compliant. Encryption at rest and in transit, two-factor on every login, audit log on every action, BAA written for AI, and a clean exit if you ever leave. Built to the 2026 HIPAA Security Rule.',
		path: '/hipaa/',
		pageType: 'WebPage'
	}
});
